export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20illustration%20with%20soft%20golden%20and%20terracotta%20gradients%2C%20subtle%20comic%20panel%20textures%20floating%20gently%2C%20dreamy%20bokeh%20effects%2C%20elegant%20Korean%20manhwa%20aesthetic%20atmosphere%2C%20warm%20lighting%20with%20cream%20and%20rose%20tones%2C%20minimalist%20decorative%20line%20art%20elements%2C%20sophisticated%20literary%20vibe&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="韩漫网背景"
          className="w-full h-full object-cover object-top opacity-30"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/10 via-background-50/30 to-background-50/90"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide mb-5 whitespace-nowrap">
              热门韩漫 · 每日更新
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-4">
              韩漫网 · 韩漫全集免费阅读平台
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              全本已完结韩漫，下拉式畅快阅读
            </p>

            <div className="space-y-3 mb-8 max-w-xl mx-auto lg:mx-0">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                韩漫网是国内专业的韩漫大全资源整理平台，为你精选海量韩漫全集、韩漫完结及韩漫完整版作品。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                无论你是追更热门连载，还是寻找韩漫全本已完结的经典佳作，这里都能量身推荐。每日更新追踪，下拉式阅读体验，让每一次追漫都流畅尽兴。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                本周重点更新：《月光宫殿》剧情大转折、《恶女的救赎》第三季高能回归、《某天成为公主》完结篇全卷可阅。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">5,200+</div>
                <div className="text-xs text-foreground-500 mt-1">收录作品</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-500">360+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新话数</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-secondary-500">日更追踪</div>
                <div className="text-xs text-foreground-500 mt-1">全天候更新保障</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                开始阅读
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3 border border-background-300 text-foreground-700 rounded-md font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                查看榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px] flex-shrink-0">
            <div className="relative">
              <div className="w-full aspect-[3/4] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20in%20traditional%20hanbok-inspired%20dress%20reading%20a%20glowing%20book%20under%20moonlight%2C%20floating%20magical%20pages%20and%20ink%20brush%20strokes%20around%20her%2C%20soft%20warm%20golden%20and%20rose%20color%20palette%2C%20dreamy%20atmosphere%2C%20delicate%20line%20art%2C%20romantic%20fantasy%20aesthetic%20with%20subtle%20sparkle%20effects%2C%20vertical%20composition&width=800&height=1066&seq=hero-visual-main&orientation=portrait"
                  alt="韩漫网主题视觉 - 月光下的韩漫阅读"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-accent-500 text-background-50 dark:text-foreground-950 px-4 py-2 rounded-md text-xs font-medium whitespace-nowrap">
                每日更新 · 免费阅读
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}